import { create } from "zustand";
import { persist, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

interface ModuleCount {
  [key: string]: {
    count: string;
    loading: boolean;
  };
}

type ModulesCountStore = {
  triggerKeys: string[];
  pinnedMens: string[];
  modulesCount: ModuleCount;
  updatePinnedMens: (data: string[]) => void;
  updateModulesCount: (data: ModuleCount) => void;
};

type SideMenuExpandStore = {
  expand: boolean;
  updateExpand: (data: boolean) => void;
};

export const useModulesCountStore = create<ModulesCountStore>()(
  persist(
    subscribeWithSelector(
      immer((set, get) => ({
        pinnedMens: ['aiAssistant'],
        modulesCount: {},
        triggerKeys: [],
        updateModulesCount(data) {
          set((state) => {
            state.modulesCount = data;
          });
        },
        updatePinnedMens(data) {
          set((state) => {
            state.pinnedMens = data;
          });
        },
      }))
    ),
    {
      name: "global-module-store",
    }
  )
);


export const useSideMenuExpandStore = create<SideMenuExpandStore>()(
  persist(
    subscribeWithSelector(
      immer((set, get) => ({
        expand: false,
        updateExpand(data) {
          set((state) => {
            state.expand = data;
          });
        },
      }))
    ),

    {
      name: "sideMenu-expand-store",
    }
  )
);
